import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Order_id_holder.css";
import Return_Lottie from "../../../Animation/return_Lottie/Return_Lottie";
import { formatDateTime } from "../../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { appSetup } from "../../../../features/master/masterSlice";

function Order_id_holder({ headingText, subText, order }) {
  const location = useLocation();
  const isReturnPage = location.pathname === "/return-order-details";

  const dispatch = useDispatch();
  const app_setup = useSelector((state) => state.master.app_setup);

  // useEffect(() => {
  //   dispatch(appSetup());
  // }, [dispatch]);
  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <>
      <section className="Order_id_holder">
        <div className="order_id">
          <div className="img_id_holder">
            {!isReturnPage && (
              <div>
                <div className="img_holder">
                  <img
                    className="Product_img"
                    // src={ process.env.PUBLIC_URL +   "/assets/images/logo/new_ekansi_logo.png"}
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    alt="Product"
                  />
                </div>
              </div>
            )}

            {isReturnPage && (
              <div className="animation_holder">
                <Return_Lottie />
              </div>
            )}

            <div className="ms-3">
              <h2 className="para_secondary_text ">
                {order?.invoice_no || order?.Product_Order?.invoice_no}
              </h2>
              {(order?.tracking_id || order?.Product_Order?.tracking_id) && (
                <h3 className=" tracking_id">
                  <span>Tracking Id : </span>
                  {order?.tracking_id || order?.Product_Order?.tracking_id}
                </h3>
              )}
              <p
                style={{
                  fontSize: "10px",
                  fontWeight: "600",
                }}
              >
                {subText}
              </p>
            </div>
          </div>

          <div>
            <p>{formatDateTime(order?.updatedAt)}</p>
            <button
              className="Downloadinvoicebtn"
              onClick={() =>
                downloadInvoice(
                  process.env.REACT_APP_IMG_URL +
                    (order?.invoice || order?.Product_Order?.invoice),
                )
              }
            >
              Download Invoice
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_id_holder;
